import { render, staticRenderFns } from "./DeptBaseInfo.vue?vue&type=template&id=578d2c11&scoped=true"
import script from "./DeptBaseInfo.vue?vue&type=script&lang=js"
export * from "./DeptBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./DeptBaseInfo.vue?vue&type=style&index=0&id=578d2c11&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578d2c11",
  null
  
)

export default component.exports